"use no memo";

/* eslint-disable import/prefer-default-export */

export async function geocode(param) {
  const { Geocoder } = await window.google.maps.importLibrary('geocoding');
  const geocoder = new Geocoder();

  return new Promise((resolve, reject) => {
    geocoder.geocode(param, (result, status) => {
      if (status === 'OK') {
        resolve(result);
      } else {
        reject(status);
      }
    });
  });
}
